<template>
  <div>
    <the-nav-bar :title="$t('orderDetail.name')" class="nav-bar">
      <md-button
        class="nav-bar-right"
        plain
        inline
        type="primary"
        slot="right"
        @click="onConversateClick"
        v-if="conversationUrl"
      >
        <div class="row-align-center">
          <svg class="nav-bar-right-icon">
            <use xlink:href="#icon-message" />
          </svg>
          <span class="nav-bar-right-text">
            {{ $t('orderDetail.joinChat') }}
          </span>
        </div>
      </md-button>
    </the-nav-bar>
    <div class="body-wrapper" v-if="isLoaded">
      <md-scroll-view ref="scrollView" :scrolling-x="false" auto-reflow>
        <div
          class="scroll-wrapper"
          :class="{ 'have-button': botton.length > 0 }"
        >
          <div class="order-status row">
            <div class="type">
              <span class="icon-image">
                <img :src="asset.iconUrl" :alt="asset.symbol" />
              </span>
              <span>
                {{ type === 'buy' ? $t('common.buy') : $t('common.sell') }}
                {{ asset.symbol }}
              </span>
            </div>
            <div class="status" :class="orderStatus">
              {{ $t(`orders.${orderStatus}`) }}
            </div>
          </div>
          <div class="time">
            <span>{{ createdAt }}</span>
          </div>
          <div class="order-detail">
            <div class="order-detail-item row">
              <div class="detail-title">
                {{ $t('orderDetail.orderNumber') }}
              </div>
              <div
                class="detail-content bold row-center"
                @click="$copyText(orderId)"
              >
                {{ orderId }}
                <svg class="icon-copy">
                  <use xlink:href="#icon-copy" />
                </svg>
              </div>
            </div>
            <div class="order-detail-item row" v-if="otherPhone">
              <div class="detail-title">
                {{
                  $t(
                    `orderDetail.${
                      type === 'buy' ? 'sellerPhone' : 'buyerPhone'
                    }`,
                  )
                }}
              </div>
              <div class="detail-content bold row-center" v-if="!isVisible">
                <a>{{ otherPhone | hidePhoneNumber }}</a>
                <svg class="icon-visible" @click="toggleVisible">
                  <use xlink:href="#icon-eye-close" />
                </svg>
              </div>
              <div class="detail-content bold row-center" v-else>
                <svg class="icon-copy"   @click="$copyText(otherPhone)">
                  <use xlink:href="#icon-copy" />
                </svg>
                <a :href="`tel:${otherPhone}`">{{ otherPhone }}</a>
                <svg class="icon-visible" @click="toggleVisible">
                  <use xlink:href="#icon-eye-open" />
                </svg>
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title">{{ $t('orderDetail.buyer') }}</div>
              <div class="detail-content bold">
                {{ receiverName }}
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title">{{ $t('orderDetail.seller') }}</div>
              <div class="detail-content bold">
                {{ payerName }}
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title">
                {{ $t('orderDetail.cryptoWallet') }}
              </div>
              <div class="detail-content">
                <svg class="icon">
                  <use xlink:href="#icon-mixin" />
                </svg>
                <span class="bold">{{ 'Mixin' }}</span>
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title">
                {{ $t('orderDetail.paymentMethods') }}
              </div>
              <div class="detail-content">
                <img
                  :src="getPayIcon(payMethod)"
                  :alt="payMethod"
                  class="icon"
                />
                <span class="bold">{{ $t(`payments.${payMethod}`) }}</span>
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title">{{ $t('orderDetail.amount') }}</div>
              <div class="detail-content">
                <span class="bold">{{ assetAmount | noSci }}</span>
                <span class="symbol"> {{ asset.symbol }}</span>
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title">{{ $t('orderDetail.price') }}</div>
              <div class="detail-content">
                <span class="bold">{{ payAssetPrice }}</span>
                <span class="symbol">
                  {{ `${asset.symbol}/${legalCurrency.symbol}` }}</span
                >
              </div>
            </div>
            <div class="order-detail-item row">
              <div class="detail-title total">
                {{ $t('orderDetail.total') }}
              </div>
              <div class="detail-content total">
                <span>{{ allPrice }}</span>
                <span class="symbol"> {{ legalCurrency.symbol }}</span>
              </div>
            </div>
          </div>
          <div class="order-evaluate" v-if="your.rank || other.rank">
            <div class="order-evaluate-item row" v-if="your.rank">
              <div class="evaluate-title">
                {{ $t('orderDetail.yourRating') }}
              </div>
              <div class="evaluate-content row">
                <div class="content-detail" v-if="your.reason">
                  {{ your.reason }}
                </div>
                <div class="content type row" v-if="your.rank === 1">
                  <svg class="icon">
                    <use xlink:href="#icon-negative" />
                  </svg>
                  <p class="bold">{{ $t('evaluation.bad') }}</p>
                </div>
                <div class="content type row" v-else-if="your.rank === 3">
                  <svg class="icon">
                    <use xlink:href="#icon-moderate" />
                  </svg>
                  <p class="bold">{{ $t('evaluation.mid') }}</p>
                </div>
                <div class="content type row" v-else>
                  <svg class="icon">
                    <use xlink:href="#icon-positive" />
                  </svg>
                  <p class="bold">{{ $t('evaluation.good') }}</p>
                </div>
              </div>
            </div>
            <div class="order-evaluate-item row" v-if="other.rank">
              <div class="evaluate-title">
                {{ $t('orderDetail.opponentRating') }}
              </div>
              <div class="evaluate-content row">
                <div class="content-detail" v-if="other.reason">
                  {{ other.reason }}
                </div>
                <div class="content type row" v-if="other.rank === 1">
                  <svg class="icon">
                    <use xlink:href="#icon-negative" />
                  </svg>
                  <p class="bold">{{ $t('evaluation.bad') }}</p>
                </div>
                <div class="content type row" v-else-if="other.rank === 3">
                  <svg class="icon">
                    <use xlink:href="#icon-moderate" />
                  </svg>
                  <p class="bold">{{ $t('evaluation.mid') }}</p>
                </div>
                <div class="content type row" v-else>
                  <svg class="icon">
                    <use xlink:href="#icon-positive" />
                  </svg>
                  <p class="bold">{{ $t('evaluation.good') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="order-schedule">
            <h2>{{ $t('orderDetail.orderProgress') }}</h2>
            <div class="schedule">
              <md-steps
                direction="vertical"
                :steps="log"
                :current="log.length"
                :vertical-adaptive="false"
              >
                <div
                  class="custom-content"
                  slot="content"
                  slot-scope="{ step }"
                >
                  <template>
                    <p
                      class="step active"
                      v-text="$t(`logStatus.${step.type}`)"
                    ></p>
                    <p
                      class="date"
                      v-text="
                        moment(step.createdAt * 1000).format(
                          'YYYY/MM/DD HH:mm:ss',
                        )
                      "
                    ></p>
                    <p class="text" v-html="step.content"></p>
                  </template>
                </div>
                <template slot="current">
                  <div class="success"></div>
                </template>
              </md-steps>
            </div>
          </div>
        </div>
      </md-scroll-view>
      <div class="bottom">
        <div class="button-wrapper row" v-if="botton.length > 0">
          <md-button
            round
            class="left"
            :class="{ only: botton.length === 1 }"
            v-if="botton[0]"
            @click="beforeGoToUrl(botton[0].url, botton[0].method)"
          >
            {{ botton[0].name }}
          </md-button>
          <md-button
            round
            type="primary"
            class="right"
            v-if="botton[1]"
            @click="beforeGoToUrl(botton[1].url, botton[1].method)"
          >
            {{ botton[1].name }}
          </md-button>
        </div>
        <div class="help">
          <p>
            {{ $t('orderDetail.assistance') }}
          </p>
        </div>
      </div>
    </div>
  <!-- 托管资产确认弹窗-->
  <md-dialog
      :title="this.$t('common.escrowConfirmTitle')"
      :closable="false"
      v-model="escrowDialog.open"
      :btns="escrowDialog.btns"
    >
        {{ $t('common.escrowConfirmText0')  }}<br/>

        <span>{{ $t('common.mixinIDTitle') }}</span>
        <span style="font-weight:bold;color:darkblue;">
        {{$t('common.robotMixinID')}} 
        </span>  
        <span>{{ $t('common.nameTitle') }}</span>
        <span style="font-weight:bold;color:darkblue;">
        {{$t('common.robotName')}} 
        </span>  
        <br/>

        <span>{{$t('common.escrowConfirmText1')}}</span>
      
    </md-dialog>



 <!-- 释放资产确认弹窗-->
   <md-dialog
      :title="this.$t('common.releaseConfirmTitle')"
      :closable="false"
      v-model="releaseDialog.open"
      :btns="releaseDialog.btns"
    >

        <span style="font-weight:bold;color:black;">
        {{$t('common.releaseConfirmText0')}}
        </span>  

        {{$t('common.releaseConfirmText1')}}
   
        <span style="font-weight:bold;color:red;">
        {{releaseDialog.randCode}}
        </span>   

     <md-codebox
      v-model="releaseDialog.code"
      :maxlength="4"
      autofocus
      is-view
      justify
    />
      
    </md-dialog>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { ScrollView, Steps, Button, Toast, Dialog,Popup, Agree ,Codebox} from 'mand-mobile';
import { mapState } from 'vuex';
import moment from 'moment';
import getOrderDetail from '@/api/get-order-detail';
import postDetail from '@/api/post-detail-result';
import getPayIcon from '@/utils/get-payment-icon';
import noSci from '@/utils/no-sci.js';
import { getMixinAuth } from '@/api/user';
export default {
  components: {
    [ScrollView.name]: ScrollView,
    TheNavBar,
    [Steps.name]: Steps,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [Agree.name]: Agree,
    [Codebox.name]: Codebox,

  },
  filters: {
    noSci,
    hidePhoneNumber(val) {
      if (/^\+86/.test(val)) {
        return '+86****';
      }
      return val.slice(0, 3) + '****';
    },
  },
  data() {
    return {
      isLoaded: false,
      isVisible: false,
      id: '',
      type: '',
      asset: {
        iconUrl: '',
        symbol: '',
        mixinId: '',
      },
      orderId: '',
      payerName: '',
      receiverName: '',
      traderId: '',
      createdAt: '',
      orderStatus: '',
      allPrice: '',
      assetAmount: '',
      payAssetPrice: '',
      payMethod: '',
      your: {
        rank: '',
        reason: '',
      },
      other: {
        rank: '',
        reason: '',
      },
      legalCurrency: {
        symbol: '',
      },
      log: [],
      botton: [],
      orderDetailInterval: null,
      conversationUrl: '',
      otherPhone: '',
      releaseDialog: {//释放资产弹窗窗口
        randCode: '',
        code: '',
        path: '',
        method: '',
        open: false,
        btns: [
          {
            text: this.$t('result.close'),
          },
          {
            text: this.$t('common.confirm'),
            warning: true,
            handler: this.onReleaseConfirm,
          },
        ],
      },
      escrowDialog: {//托管资产弹窗窗口
        path: '',
        method: '',
        open: false,
        btns: [
          {
            text: this.$t('result.close'),
          },
          {
            text: this.$t('common.confirmPayEscrow'),
            warning: true,
            handler: this.onEscrowConfirm,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
    }),
  },
  mounted() {
    this.releaseDialog.randCode = Math.floor(Math.random() * 9000) + 1000;
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      Toast.loading(this.$t('common.loading'));
      this.getDetail();
      this.orderDetailInterval = setInterval(
        () =>
          getOrderDetail(this.id, this.navLang)
            .then(data => {
              this.loadData(data);
              if (['cancel', 'success'].includes(this.orderStatus)) {
                clearInterval(this.orderDetailInterval);
              }
            })
            .catch(err => {
              Toast.failed(err.message || this.$t('error.unknown'));
            }),
        5000,
      );
    }
  },
  beforeDestroy() {
    clearInterval(this.orderDetailInterval);
  },
  methods: {
    moment,
    getPayIcon(payMethod) {
      return getPayIcon.call(null, payMethod);
    },
    getDetail() {
      return getOrderDetail(this.id, this.navLang).then(data => {
        this.loadData(data);
        this.isLoaded = true;
        Toast.hide();
      });
    },
    toggleVisible() {
      this.isVisible = !this.isVisible;
    },
    loadData(data) {
      const d = data.data;
      this.type = d.type;
      this.asset = d.asset;
      this.orderId = d.orderId;
      this.payerName = d.payerTrueName
        ? `${d.payerName}（${d.payerTrueName}）`
        : d.payerName;
      this.receiverName = d.receiverTrueName
        ? `${d.receiverName}（${d.receiverTrueName}）`
        : d.receiverName;
      this.traderId = this.type === 'buy' ? d.receiverId : d.payerId;
      this.createdAt = moment(d.createdAt * 1000).format('YYYY/MM/DD HH:mm:ss');
      this.orderStatus = d.orderStatus;
      this.allPrice = d.allPrice;
      this.assetAmount = d.assetAmount;
      this.payAssetPrice = d.payAssetPrice;
      this.legalCurrency.symbol = d.legalCurrency.symbol;
      this.payMethod = d.payMethod;
      this.log = d.log;
      this.botton = d.botton;
      this.your.rank = d.your.rank ? d.your.rank : '';
      this.your.reason = d.your.reason ? d.your.reason : '';
      this.other.rank = d.other.rank ? d.other.rank : '';
      this.other.reason = d.other.reason ? d.other.reason : '';
      this.conversationUrl = d.conversationUrl;
      this.otherPhone = d.otherPhone;
    },
    onEscrowConfirm() { //托管资产弹窗确认按钮
      this.escrowDialog.open = false;
      this.goToUrl(this.escrowDialog.path, this.escrowDialog.method);
    },
    onReleaseConfirm() { //释放资产弹窗确认按钮
      if(this.releaseDialog.code == this.releaseDialog.randCode){
        this.releaseDialog.open = false;
        this.goToUrl(this.releaseDialog.path, this.releaseDialog.method);
      }else{
        Toast.failed(this.$t('common.releaseCodeError'));
      }
    },
    beforeGoToUrl(path, method) {
      this.releaseDialog.path = path;
      this.releaseDialog.method = method;
      this.escrowDialog.path = path;
      this.escrowDialog.method = method;
      if(path.includes('release')){
        this.releaseDialog.open = true;
        return;
      }else if(path.includes('escrow_direct')){//托管也分两步，弹窗提示
        this.escrowDialog.open = true;
        return;
      }else{
        this.goToUrl(path, method);
      }
    },
    goToUrl(path, method) {
      if (method === 'get') {
        this.$router.push({ path, query: { fromDetail: true } });
      } else {
        Toast.loading(this.$t('common.loading'));
        return postDetail(path)
          .then(data => {
            if (data.data && data.data.mixin_url) {
              Toast.hide();
              window.location.replace(
                data.data.mixin_url,
              );
              return;
            }
            getOrderDetail(this.id, this.navLang)
              .then(data => {
                this.loadData(data);
                Toast.hide();
              })
              .catch(err => {
                Toast.hide();
                Toast.failed(err.message || this.$t('error.unknown'));
              });
          })
          .catch(err => {
            Toast.hide();
            if (err.code == '1075') {
              return Dialog.confirm({
                icon: '',
                title: err.message,
                cancelText: this.$t('common.cancel'),
                confirmText: this.$t('common.reauthorize'),
                onConfirm: () => {
                  getMixinAuth()
                    .then(data => {
                      return window.location.replace(data.data.url);
                    })
                    .catch(err => {
                      Toast.failed(err.message);
                    });
                },
              });
            }
            Toast.failed(err.message || this.$t('error.unknown'));
          });
      }
    },
    onConversateClick() {
      window.open(this.conversationUrl);
    },
    goRelated(type) {
      if (this.type !== type && this.traderId) {
        this.$router.push({
          path: '/exchange/related',
          query: {
            id: this.traderId,
          },
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.nav-bar-right {
  margin-right: 4.8vw;
  height: 5.87vw;
  line-height: 5.87vw;

  .nav-bar-right-icon {
    margin-right: 1.07vw;
    width: 4.8vw;
    height: 4.8vw;
  }

  .nav-bar-right-text {
    font-size: 2.67vw;
  }
}

>>>.md-number-keyboard-container .keyboard-number{
 background:transparent;
}
>>>.md-number-keyboard-container::after {
  border-top: transparent;
}

.body-wrapper {
  position: absolute;
  absolute-pos(11.73vw);
  background: #efefef;

  .scroll-wrapper {
    margin-bottom: 18vw;

    &.have-button {
      margin-bottom: 27vw;
    }
  }

  .order-status {
    height: 11.2vw;
    line-height: 15.2vw;
    border-top: 2.13vw solid #f8fbfc;
    padding: 0 4.8vw;
    background-color: #fff;
    justify-content: space-between;

    .type {
      .icon-image {
        display: inline-block;
        width: 6.4vw;
        height: 6.4vw;
        position: relative;
        margin-right: 2.13vw;
        top: 2vw;

        img {
          width: 5vw;
          height: 5vw;
          vertical-align: middle;
          position: absolute;
          top: 0.7vw;
          left: 0.7vw;
        }
      }

      span {
        font-size: 3.73vw;
        color: #2C3133;
        font-weight: bold;
      }
    }

    .status {
      color: #84969c;

      &.done {
        color: #1b6fdc;
      }

      &.pending {
        color: #dc521b;
      }
    }
  }

  .time {
    display: flex;
    padding-bottom: 2.13vw;
    padding-right: 4.8vw;
    border-bottom: 0.27vw solid #EAF1F3;
    background-color: #fff;
    justify-content: flex-end;
    color: #84969C;
    font-size: 2.67vw;
  }

  .order-detail {
    background-color: #fff;
    padding-bottom: 2.13vw;
    border-bottom: 0.27vw solid #EAF1F3;

    .order-detail-item {
      justify-content: space-between;
      height: 8.53vw;
      line-height: 8.53vw;
      margin-left: 4.8vw;
      margin-right: 4.8vw;
      color: #84969C;

      .detail-title.total {
        font-weight: bold;
        color: #2C3133;
      }

      .detail-content.total {
        font-size: 4.27vw;
        color: #2C3133;
      }

      .icon {
        width: 4.8vw;
        height: 4.8vw;
        vertical-align: middle;
        margin-right: 3.13vw;
      }

      .icon-visible {
        margin-left: 1.33vw;
        width: 4.8vw;
        height: 4.8vw;
      }

      .icon-copy {
        margin-left: 1.33vw;
        width: 4.8vw;
        height: 4.8vw;
        vertical-align: middle;
      }

      .symbol {
        font-size: 2.67vw;
      }

      .bold {
        font-weight: bold;
      }
    }
  }

  .order-evaluate {
    background-color: #fff;
    padding-top: 2.13vw;
    padding-bottom: 4.8vw;

    .order-evaluate-item {
      justify-content: space-between;
      min-height: 8.53vw;
      line-height: 8.53vw;
      margin-left: 4.8vw;
      margin-right: 4.8vw;
      color: #84969C;

      .content-detail {
        font-size: 2.67vw;
        margin-right: 2.13vw;
        padding-left: 2.67vw;
        padding-right: 2.67vw;
        background: #F8FBFC;
        max-width: 50vw;
      }

      .content {
        .icon {
          height: 6.67vw;
          width: 6.67vw;
          margin-right: 2.13vw;
          margin-top: 0.6vw;
        }

        .bold {
          font-weight: bold;
        }
      }
    }
  }

  .order-evaluate-item:first-child {
    margin-bottom: 2.13vw;
  }

  .order-schedule {
    background-color: #fff;
    padding-bottom: 3vw;

    h2 {
      height: 13.33vw;
      line-height: 16.33vw;
      padding-left: 4.8vw;
      margin-top: 0;
      margin-bottom: 0;
      border-bottom: 0.27vw solid #EAF1F3;
      border-top: 2.13vw solid #f8fbfc;
    }

    .schedule {
      .md-steps {
        margin-left: 17vw;

        .step {
          color: #BCC7CB;
          font-size: 3.2vw;
          position: absolute;
          width: 17vw;
          left: -21vw;
        }

        .date {
          color: #BCC7CB;
          font-size: 2.67vw;
        }

        .text {
          color: #84969C;
          font-size: 2.67vw;
          min-height: 8vw;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        .success {
          display: block;
          width: 2vw;
          height: 2vw;
          border-radius: 100%;
          background: #1b6fdc;
        }

        /deep/ .vertical-bar {
          max-height: 15.27vw !important;
        }
      }
    }
  }

  .bottom {
    background: #FFF;
    width: 100%;
    padding-top: 2.13vw;
    position: fixed;
    bottom: 0vw;
    z-index: 101;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;

    .button-wrapper {
      justify-content: space-around;

      .left {
        width: 42.67vw;
        height: 9.6vw;
        color: #1b6fdc;
        background: #F8FBFC;
        margin-left: 4.8vw;

        /deep/&::after {
          border-color: #1b6fdc;
        }

        &.only {
          margin-left: 0;
          background: #07B9A6;
          color: #F8FBFC;
        }
      }

      .right {
        width: 42.67vw;
        height: 9.6vw;
        margin-right: 4.8vw;
      }
    }

    .help {
      p {
        font-size: 3.2vw;
        color: #84969C;
        text-align: center;
        margin: 2.13vw 4.8vw 4.13vw;

        span {
          color: #1b6fdc;
        }
      }
    }
  }
}
</style>
